import { Skeleton } from "@mui/material";
import type { FunctionComponent } from "react";

interface PersonalSkeletonProps {
}

const PersonalSkeleton: FunctionComponent<PersonalSkeletonProps> = () => {
    
    // Array para iterar los 4 campos de datos
    const placeholderItems = Array.from(new Array(4));
    
    return (
        <>
            <div className="w-full max-w-4xl mx-auto">
                {/* --- SECCIÓN SUPERIOR: Avatar, Nombre y Rol --- */}
                <div className="flex flex-col items-center pb-4">
                    {/* Avatar grande */}
                    <Skeleton variant="circular" width={80} height={80} animation="pulse" className="mb-3" />
                    {/* Contenedor para Nombre*/}
                    <div className="flex items-center justify-center gap-3 w-full">
                        {/* Nombre */}
                        <Skeleton variant="text" width={300} height={36} animation="pulse" />
                    </div>
                    {/* Rol (ej. ABOGADO) */}
                    <Skeleton variant="text" width={130} height={20} animation="pulse" />
                </div>


                {/* --- SECCIÓN INFERIOR: Tarjeta de Detalles --- */}
                <div className="bg-white border border-gray-200 rounded-[2rem] p-4 relative shadow-sm">
                    {/* Grid de 2 columnas para los datos */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {placeholderItems.map((_, index) => (
                            // Contenedor interno de cada dato (caja gris clara)
                            <div key={index} className="flex items-center gap-5 p-5 bg-gray-50 rounded-2xl border border-gray-100/50">
                                {/* Icono circular izquierdo con tinte azulado */}
                                <Skeleton
                                    variant="circular"
                                    width={40}
                                    height={40}
                                    animation="pulse"
                                    className="shrink-0 bg-blue-50/80"
                                />

                                {/* Bloque de texto (Label y Valor) */}
                                <div className="flex flex-col space-y-2 flex-1">
                                    {/* Label (ej. CORREO ELECTRÓNICO) */}
                                    <Skeleton variant="text" width={110} height={16} animation="pulse" />
                                    {/* Valor (ej. el correo) */}
                                    <Skeleton variant="text" width="75%" height={24} animation="pulse" className="rounded-md" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </>
    );
}

export default PersonalSkeleton;